import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { Eye, EyeOff } from "lucide-react";
import UITextField from "../UITextField";

const UIPasswordField = ({ InputProps, ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <UITextField
      type={visible ? "text" : "password"}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              aria-label={visible ? "Hide password" : "Show password"}
              onClick={() => setVisible((current) => !current)}
              onMouseDown={(event) => event.preventDefault()}
            >
              {visible ? (
                <EyeOff
                  size={24}
                  strokeWidth={2}
                  color="var(--Proline-ActionStroke, rgba(107, 119, 140, 1))"
                />
              ) : (
                <Eye
                  size={24}
                  strokeWidth={2}
                  color="var(--Proline-ActionStroke, rgba(107, 119, 140, 1))"
                />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

UIPasswordField.propTypes = {
  InputProps: PropTypes.object,
};

UIPasswordField.defaultProps = {
  InputProps: {},
};

export default UIPasswordField;
